import { Link } from 'react-router-dom';

interface HeroBannerProps {
  title: string;
  subtitle: string;
  description: string;
  cta: string;
  stats: { videos: string; videosLabel: string; daily: string; dailyLabel: string; users: string; usersLabel: string };
}

export default function HeroBanner({ title, subtitle, description, cta, stats }: HeroBannerProps) {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20theatrical%20interior%20with%20red%20velvet%20curtains%20and%20golden%20spotlight%2C%20cinematic%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20elegant%20movie%20theater%20with%20empty%20stage%2C%20rich%20warm%20tones%2C%20professional%20photography%2C%20dark%20atmospheric%20edges&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="红桃视频在线观看 - 免费高清视频播放平台"
        title="红桃视频在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 py-20 md:py-28">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          红桃视频在线观看
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-white/90 font-heading mb-4">
          {subtitle}
        </p>
        <p className="max-w-2xl mx-auto text-sm md:text-base text-white/70 leading-relaxed mb-8">
          {description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link
            to="/category/movie"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-play-fill mr-2"></i>
            {cta}
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border-2 border-white/30 text-white font-medium text-base hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stats.videos}</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">{stats.videosLabel}</div>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stats.daily}</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">{stats.dailyLabel}</div>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stats.users}</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">{stats.usersLabel}</div>
          </div>
        </div>
      </div>
    </section>
  );
}